import { animate, style, transition, trigger } from '@angular/animations';


const FIRST_ANIMATION_START_TIME = 400;
const FIRST_ANIMATION_END_TIME = 300;
const SECOND_ANIMATION_START_TIME = 400;
const SECOND_ANIMATION_END_TIME = 300;

/**
 * This section describes the animation behavior when ngIf conditions are met.
 *
 * When *ngIf condition is true, the :enter animation is triggered.
 * When *ngIf condition becomes false, the :leave animation is triggered.
 *
 * If you have two consecutive animations, consider using different animation triggers for each of them.
 * For instance, use "fadeInOut" for the first div, and "fadeInOut2" for the second div.
 * This approach ensures a smooth transition as "fadeInOut2" will only start after "fadeInOut" is completed.
 *
 * For displaying a skeleton loading animation followed by the actual content in the same place,
 * create a parent div with the CSS class .overlap-children.
 */
export const fadeInOutAnimation = (
  firstAnimationStartTime = FIRST_ANIMATION_START_TIME,
  firstAnimationEndTime = FIRST_ANIMATION_END_TIME) => trigger('fadeInOut', [
  transition(':enter', [
    style({ opacity: 0 }),
    animate(`${firstAnimationStartTime}ms`, style({ opacity: 1 })),
  ]),
  transition(':leave', [
    animate(`${firstAnimationEndTime}ms`, style({ opacity: 0 })),
  ]),
]);

export const fadeInOutAfterFirstAnimation = (
  firstAnimationEndTime = FIRST_ANIMATION_END_TIME,
  secondAnimationStartTime = SECOND_ANIMATION_START_TIME,
  secondAnimationEndTime = SECOND_ANIMATION_END_TIME) => trigger('fadeInOut2', [
  transition(':enter', [
    animate(0, style({ opacity: 0 })),
    animate(`${firstAnimationEndTime}ms`, style({ opacity: 0 })),
    animate(`${secondAnimationStartTime}ms`, style({ opacity: 1 })),
  ]),
  transition(':leave', [
    animate(`${secondAnimationEndTime}ms`, style({ opacity: 0 })),
  ]),
]);
